// Copyright (C) 2021 Bystronic Laser AG

import { EChartsOption } from 'echarts';
import { GeneratorParams } from '../generatorParams';
import { ChartGenerator, ProcedureName } from './chartGenerator';
import { formatPercentage } from '@/utils/number';
import { PieDataItemOption } from 'echarts/types/src/chart/pie/PieSeries';

export default abstract class DoublePieChartKpiWidgetGenerator<
  T,
> extends ChartGenerator<T> {
  constructor(
    procedure: ProcedureName,
    protected customerIdDh: number,
    protected mainColor: string,
  ) {
    super(procedure);
  }

  abstract formatTooltipValue(value: number): string;

  abstract generateOuterPieSeries(data: T): PieDataItemOption[];

  abstract generateInnerPieSeries(data: T): PieDataItemOption[];

  protected tooltipFormatter(params: any): string {
    const { name, percent, value } = params;
    return `${name}: <b>${this.formatTooltipValue(
      value,
    )}</b> (${formatPercentage(percent)})`;
  }

  override updateOptions(
    data: T,
    parameters: GeneratorParams,
    prevOptions?: EChartsOption,
  ): EChartsOption {
    return {
      tooltip: {
        trigger: 'item',
        formatter: (params: any) => this.tooltipFormatter(params),
      },
      series: [
        {
          name: 'inner-pie',
          type: 'pie',
          selectedMode: 'single',
          radius: ['20%', '45%'],
          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
          data: this.generateInnerPieSeries(data),
        },
        {
          name: 'outer-pie',
          type: 'pie',
          radius: ['70%', '90%'],
          label: {
            show: false,
          },
          data: this.generateOuterPieSeries(data),
        },
      ],
    };
  }
}
